import {
  arrayOf,
  shape,
  string,
  bool,
} from 'prop-types';

const updateStatusActivityShape = shape({
  newTLStatus: string,
  oldTLStatus: string,
  initiatorName: string,
  note: string,
  driverCity: string,
  driverState: string,
  loadId: string,
  eventId: string,
  eventTime: string,
  eventType: string,
  resolvedProblems: arrayOf(string),
  isAutomated: bool,
});

export default updateStatusActivityShape;
